// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"580":"5257d4f7","646":"75550108","787":"f5d4183f","819":"afcd4c8a","893":"ff8d3e30","962":"1ecf62d1"}[chunkId] + ".chunk.js";
};